<template>
    <main class="legal-page">

        <section class="legal-hero">

            <div class="legal-hero__orb legal-hero__orb--one"></div>
            <div class="legal-hero__orb legal-hero__orb--two"></div>

            <div class="container">

                <div class="legal-hero__content">

                    <div class="legal-hero__meta">

                        <span class="legal-hero__line"></span>

                        <span class="legal-hero__eyebrow">
                            LEGAL / 02
                        </span>

                    </div>

                    <h1 v-if="pageContent">
                        {{ pageContent.title }}
                    </h1>

                    <p
                        v-if="pageContent && pageContent.content_alt"
                        class="legal-hero__description"
                    >
                        {{ pageContent.content_alt }}
                    </p>

                    <div class="legal-hero__footer">

                        <span>
                            DANTRIX PRO
                        </span>

                        <span>
                            TÉRMINOS Y CONDICIONES
                        </span>

                    </div>

                </div>

            </div>

        </section>

        <section class="legal-content">

            <div class="container">

                <div
                    v-if="pageContent"
                    class="legal-layout"
                >

                    <aside class="legal-sidebar">

                        <span class="legal-sidebar__label">
                            DOCUMENTO
                        </span>

                        <strong>
                            02
                        </strong>

                        <span class="legal-sidebar__line"></span>

                        <span class="legal-sidebar__text">
                            TÉRMINOS Y CONDICIONES
                        </span>

                    </aside>

                    <article class="legal-document">

                        <div class="legal-document__top">

                            <span>
                                DANTRIX PRO
                            </span>

                            <span>
                                DOCUMENTO LEGAL
                            </span>

                        </div>

                        <div class="legal-document__body">

                            <vue-marked>
                                {{ pageContent.content }}
                            </vue-marked>

                        </div>

                    </article>

                </div>

                <div
                    v-else
                    class="legal-empty"
                >

                    <span>
                        404 / LEGAL
                    </span>

                    <h2>
                        Contenido no disponible
                    </h2>

                    <p>
                        El documento solicitado todavía no se encuentra disponible.
                    </p>

                    <router-link to="/">
                        VOLVER AL INICIO
                        <span>↗</span>
                    </router-link>

                </div>

            </div>

        </section>

        <section
            v-if="pageContent"
            class="legal-end"
        >

            <div class="container">

                <div class="legal-end__inner">

                    <div>

                        <span class="legal-end__eyebrow">
                            DANTRIX PRO / LEGAL
                        </span>

                        <h2>
                            ¿TIENES ALGUNA DUDA?
                        </h2>

                        <p>
                            Puedes ponerte en contacto con nosotros para cualquier consulta relacionada con estos términos.
                        </p>

                    </div>

                    <router-link
                        :to="{ name: 'Home', hash: '#contact' }"
                        class="legal-end__button"
                    >
                        CONTACTAR

                        <span>
                            ↗
                        </span>
                    </router-link>

                </div>

            </div>

        </section>

    </main>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'TermsConditions',

    computed: {
        ...mapGetters([
            'catalogPagesContent'
        ]),

        pageContent() {
            if (
                !Array.isArray(this.catalogPagesContent)
            ) {
                return null;
            }

            return this.catalogPagesContent.find(item => {
                return String(item.hash || '')
                    .trim()
                    .toLowerCase() ===
                    'terms-and-conditions';
            }) || null;
        }
    },

    mounted() {
        this.updateTitle();
    },

    watch: {
        pageContent() {
            this.updateTitle();
        }
    },

    methods: {
        updateTitle() {
            if (!this.pageContent) {
                return;
            }

            document.title =
                `DANTRIX PRO | ${this.pageContent.title}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.legal-page {
    min-height: 100vh;

    background: var(--color-1);

    color: var(--text-1);
}

.container {
    width: 100%;
    max-width: var(--container);

    margin: 0 auto;
}

.legal-hero {
    position: relative;

    min-height: 32.5em;

    display: flex;
    align-items: center;

    padding:
        8.125em 1.25em
        5em;

    background:
        radial-gradient(
            circle at 50% 30%,
            rgba(233, 81, 29, .06),
            transparent 28%
        ),
        radial-gradient(
            circle at 85% 10%,
            rgba(255, 255, 255, .025),
            transparent 22%
        ),
        var(--color-1);

    border-bottom:
        0.0625em solid
        var(--border-1);

    overflow: hidden;
}

.legal-hero__orb {
    position: absolute;

    border-radius: 50%;

    pointer-events: none;

    &--one {
        top: -16.25em;
        right: -11.25em;

        width: 32.5em;
        height: 32.5em;

        border:
            0.0625em solid
            rgba(255, 255, 255, .04);
    }

    &--two {
        bottom: -18.75em;
        left: -13.75em;

        width: 31.25em;
        height: 31.25em;

        border:
            0.0625em solid
            rgba(233, 81, 29, .06);
    }
}

.legal-hero__content {
    position: relative;

    width: 100%;
    max-width: 56.25em;

    margin: 0 auto;

    text-align: center;

    z-index: 2;
}

.legal-hero__meta {
    display: flex;
    align-items: center;
    justify-content: center;

    gap: 0.875em;

    margin-bottom: 1.375em;
}

.legal-hero__line {
    width: 2.25em;
    height: 0.0625em;

    background: var(--color-3);

    box-shadow:
        0 0 0.875em
        rgba(233, 81, 29, .35);
}

.legal-hero__eyebrow {
    color: var(--text-3);

    font-family: var(--font-tech);
    font-size: 0.625em;
    font-weight: 600;
    -letter-spacing: 0.1875em;

    text-transform: uppercase;
}

.legal-hero h1 {
    max-width: 51.25em;

    margin: 0 auto;

    color: var(--text-1);

    font-size:
        clamp(
            2.625em,
            7vw,
            4.5em
        );

    font-weight: 700;
    line-height: .95;
    -letter-spacing: -0.1875em;

    text-transform: uppercase;
}

.legal-hero__description {
    max-width: 40.625em;

    margin:
        1.5em auto
        0;

    color: var(--text-2);

    font-size: 0.9375em;
    line-height: 1.8;
}

.legal-hero__footer {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    gap: 0.75em 1.875em;

    max-width: 47.5em;

    margin:
        2.375em auto
        0;

    padding-top: 1.125em;

    border-top:
        0.0625em solid
        var(--border-1);

    span {
        color:
            rgba(255, 255, 255, .35);

        font-family: var(--font-tech);
        font-size: 0.5625em;
        -letter-spacing: 0.10625em;

        text-transform: uppercase;
    }
}

.legal-content {
    position: relative;

    padding:
        4.375em 1.25em
        6.25em;

    background:
        linear-gradient(
            180deg,
            rgba(255, 255, 255, .012),
            transparent 22%
        ),
        var(--color-1);
}

.legal-layout {
    display: grid;
    grid-template-columns: 1fr;

    gap: 2.8125em;

    max-width: 71.875em;

    margin: 0 auto;
}

.legal-sidebar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    gap: 0.75em;

    padding-bottom: 1.25em;

    border-bottom:
        0.0625em solid
        var(--border-1);

    &__label,
    &__text {
        color: var(--text-2);

        font-family: var(--font-tech);
        font-size: 0.5625em;
        -letter-spacing: 0.09375em;

        text-transform: uppercase;
    }

    strong {
        color: var(--text-3);

        font-family: var(--font-tech);
        font-size: 0.6875em;
        font-weight: 500;
    }

    &__line {
        width: 1.5625em;
        height: 0.0625em;

        background:
            rgba(255, 255, 255, .12);
    }
}

.legal-document {
    position: relative;

    border:
        0.0625em solid
        var(--border-1);

    background:
        linear-gradient(
            145deg,
            rgba(255, 255, 255, .018),
            rgba(255, 255, 255, .004)
        );

    overflow: hidden;
}

.legal-document::before {
    content: "";

    position: absolute;

    top: 0;
    left: 0;
    right: 0;

    height: 0.125em;

    background:
        linear-gradient(
            90deg,
            transparent,
            var(--color-3),
            transparent
        );

    opacity: .75;
}

.legal-document__top {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    gap: 0.625em;

    padding:
        1.0625em 1.25em;

    border-bottom:
        0.0625em solid
        var(--border-1);

    span {
        color:
            rgba(255, 255, 255, .32);

        font-family: var(--font-tech);
        font-size: 0.5em;
        -letter-spacing: 0.1em;

        text-transform: uppercase;
    }
}

.legal-document__body {
    padding:
        1.75em 1.375em
        2.1875em;

    ::v-deep h2 {
        position: relative;

        margin:
            3.125em 0
            1.25em;

        padding-left: 1.25em;

        color: var(--text-1);

        font-size:
            clamp(
                1.4375em,
                4vw,
                2em
            );

        font-weight: 600;
        line-height: 1.25;

        &::before {
            content: "";

            position: absolute;

            top: 0.1875em;
            bottom: 0.1875em;
            left: 0;

            width: 0.1875em;

            background: var(--color-3);

            box-shadow:
                0 0 0.75em
                rgba(233, 81, 29, .25);
        }
    }

    ::v-deep h2:first-child {
        margin-top: 0;
    }

    ::v-deep h3 {
        margin:
            2em 0
            0.875em;

        color: var(--text-1);

        font-size: 1.1875em;
        font-weight: 600;
        line-height: 1.4;
    }

    ::v-deep p {
        max-width: 51.25em;

        margin:
            0 0
            1.125em;

        color: #A8ADB5;

        font-size: 0.9375em;
        line-height: 1.9;
    }

    ::v-deep ul,
    ::v-deep ol {
        max-width: 5em;

        margin:
            0.625em 0
            1.5em;

        padding-left: 1.375em;

        color: #A8ADB5;
    }

    ::v-deep li {
        margin-bottom: 0.5625em;

        padding-left: 0.25em;

        font-size: 0.9375em;
        line-height: 1.75;

        &::marker {
            color: var(--text-3);
        }
    }

    ::v-deep strong {
        color: var(--text-1);

        font-weight: 600;
    }

    ::v-deep a {
        color: var(--text-3);

        text-decoration: none;

        border-bottom:
            0.0625em solid
            rgba(233, 81, 29, .32);

        transition:
            color .3s ease,
            border-color .3s ease;

        &:hover {
            color: var(--text-1);

            border-color:
                var(--color-3);
        }
    }

    ::v-deep blockquote {
        margin:
            1.875em 0;

        padding:
            1.25em 1.375em;

        border-left:
            0.125em solid
            var(--color-3);

        background:
            rgba(233, 81, 29, .045);

        color: #A8ADB5;
    }

    ::v-deep hr {
        margin:
            2.625em 0;

        border: none;

        border-top:
            0.0625em solid
            var(--border-1);
    }
}

.legal-end {
    padding:
        4.6875em 1.25em;

    border-top:
        0.0625em solid
        var(--border-1);

    background:
        radial-gradient(
            circle at 85% 50%,
            rgba(233, 81, 29, .06),
            transparent 28%
        ),
        var(--color-1);
}

.legal-end__inner {
    display: flex;
    flex-direction: column;

    gap: 2.1875em;

    max-width: 71.875em;

    margin: 0 auto;

    h2 {
        max-width: 37.5em;

        margin:
            0.625em 0
            1em;

        color: var(--text-1);

        font-size:
            clamp(
                2em,
                6vw,
                3.375em
            );

        font-weight: 700;
        line-height: .95;
        -letter-spacing: -0.125em;

        text-transform: uppercase;
    }

    p {
        max-width: 33.75em;

        margin: 0;

        color: var(--text-2);

        font-size: 0.875em;
        line-height: 1.7;
    }
}

.legal-end__eyebrow {
    color: var(--text-3);

    font-family: var(--font-tech);
    font-size: 0.5625em;
    -letter-spacing: 0.125em;

    text-transform: uppercase;
}

.legal-end__button {
    display: flex;
    align-items: center;
    justify-content: space-between;

    gap: 1.875em;

    width: 100%;
    max-width: 16.25em;

    min-height: 3.5em;

    padding:
        0 1.25em;

    border:
        0.0625em solid
        var(--color-3);

    color: var(--text-1);

    font-family: var(--font-tech);
    font-size: 0.625em;
    -letter-spacing: 0.08125em;

    transition:
        background .3s ease,
        transform .3s ease;

    span {
        color: var(--text-3);

        font-size: 1.0625em;
    }

    &:hover {
        background:
            rgba(233, 81, 29, .08);

        transform:
            translateY(-0.1875em);
    }
}

.legal-empty {
    max-width: 43.75em;

    margin: 0 auto;

    padding:
        4.375em 1.25em;

    text-align: center;

    span {
        color: var(--text-3);

        font-family: var(--font-tech);
        font-size: 0.625em;
        -letter-spacing: 0.125em;
    }

    h2 {
        margin:
            0.9375em 0;

        color: var(--text-1);

        font-size: 2.125em;
    }

    p {
        margin:
            0 0
            1.875em;

        color: var(--text-2);
    }

    a {
        display: inline-flex;
        align-items: center;

        gap: 1.125em;

        color: var(--text-3);

        font-family: var(--font-tech);
        font-size: 0.625em;
        -letter-spacing: 0.0625em;
    }
}

@media (min-width: 48em) {
    .legal-hero {
        min-height: 35em;

        padding:
            8.75em 2.5em
            5.3125em;
    }

    .legal-content {
        padding:
            5.3125em 2.5em
            7.5em;
    }

    .legal-document__body {
        padding:
            2.625em 2.5em
            3.125em;
    }

    .legal-end {
        padding:
            5.625em 2.5em;
    }

    .legal-end__inner {
        flex-direction: row;
        align-items: flex-end;
        justify-content: space-between;

        gap: 3.75em;
    }
}

@media (min-width: 68.75em) {
    .legal-hero {
        min-height: 36.25em;

        padding:
            9.0625em 3.75em
            5.625em;
    }

    .legal-content {
        padding:
            5.9375em 3.75em
            8.4375em;
    }

    .legal-layout {
        grid-template-columns:
            9.375em minmax(0, 1fr);

        gap: 3.4375em;
    }

    .legal-sidebar {
        position: sticky;

        top: 8.4375em;

        display: flex;
        flex-direction: column;
        align-items: flex-start;

        height: fit-content;

        padding:
            0 1.5625em
            0 0;

        border-bottom: none;
        border-right:
            0.0625em solid
            var(--border-1);
    }

    .legal-sidebar__line {
        width: 0.0625em;
        height: 3.125em;

        margin:
            0.5em 0;

        background:
            linear-gradient(
                180deg,
                var(--color-3),
                transparent
            );
    }

    .legal-document__body {
        padding:
            3.125em 3.4375em
            3.75em;
    }

    .legal-end {
        padding:
            6.25em 3.75em;
    }
}
</style>